import $ from 'jquery';
import FingerPrintCom from 'fingerprintjs2';
import Utility from 'UTIL/utility';
import nodeConfig from 'MODEL/config';


export default {
    init: function() {
        
        let outThis = this;
        let needPara = ['availablescreenresolution'];
        if (window.requestIdleCallback) {
            let opt = {
            };
            requestIdleCallback(function () {
                FingerPrintCom.get(opt, function (components) {
                    let paramArr = [];
                    var values = components.map(function (component) { 
                        if(needPara.indexOf(component.key.toLowerCase())> -1) {
                            paramArr.push(`${encodeURIComponent('sr')}=${encodeURIComponent(JSON.stringify(component.value))}`);
                        }
                        return component.value 
                    });
                   
                    var murmur = FingerPrintCom.x64hash128(values.join(''), 31);
                    let obj = {params: paramArr.join('&'), finger: murmur};
                    outThis.setValue(JSON.stringify(obj));
                    // outThis.pageOnload('main_page');
                })
            })
        } else {
            setTimeout(function () {
                FingerPrintCom.get(opt, function (components) {
                    let paramArr = [];
                    var values = components.map(function (component) { 
                        if(needPara.indexOf(component.key.toLowerCase())> -1) {
                            paramArr.push(`${encodeURIComponent('sr')}=${encodeURIComponent(JSON.stringify(component.value))}`);
                        }
                        return component.value 
                    });
                    var murmur = FingerPrintCom.x64hash128(values.join(''), 31);
                    let obj = {params: paramArr.join('&'), finger: murmur};
                    outThis.setValue(JSON.stringify(obj));
                    // outThis.pageOnload('main_page');
                });
            }, 500);
        }
       //setTimeout(() => {
       /*
        $(document).delegate('.kjt-data','touchend',(ev) => {
            outThis.collect(ev);
        });
        */
        /*
        $('.kjt-data').bind('touchend', (ev) => {
            
        });
        $("#app").on("touchend",".kjt-data",function(){
        });
        */
       //}, 800);
        
    },
    iosInit: function() {
        let outThis = this;
        if(this.getFingerPrintObj().finger) {
            return;
        }

        let needPara = ['availablescreenresolution'];
        let opt = {
        };
        FingerPrintCom.get(opt, function (components) {
            let paramArr = [];
            var values = components.map(function (component) { 
                if(needPara.indexOf(component.key.toLowerCase())> -1) {
                    paramArr.push(`${encodeURIComponent('sr')}=${encodeURIComponent(JSON.stringify(component.value))}`);
                }
                return component.value 
            });
           
            var murmur = FingerPrintCom.x64hash128(values.join(''), 31);
            let obj = {params: paramArr.join('&'), finger: murmur};
            outThis.setValue(JSON.stringify(obj));
            // outThis.pageOnload('main_page');
        })
    },
    setValue: function(str) {
        sessionStorage.setItem('FingerPrintJson', str);
    },
    getFingerPrintObj: function() {
        if (!sessionStorage.getItem('FingerPrintJson')) {
            return {};
        }
        return JSON.parse(sessionStorage.getItem('FingerPrintJson'));
    },
    getUrl: function() {
        let retUrl = 'https://zdata.kjtpay.com:8083/';

        switch (Utility.getOrigin()) {
            case nodeConfig.devH5CommonUrl:
              retUrl='https://zdata.kjtpay.com:8083/';
              break;
            case nodeConfig.stgH5CommonUrl:
            retUrl='https://zdata.kjtpay.com:8083/';
              break;
            case nodeConfig.stg1H5CommonUrl:
            retUrl='https://c1data.kjtpay.com:8083/';
              break;
            case nodeConfig.stg2H5CommonUrl:
            retUrl='https://c2data.kjtpay.com:8083/';
              break;
            case nodeConfig.proH5CommonUrl:
            retUrl='https://data.kjtpay.com:8083/';
              break;
            default:
            retUrl='https://zdata.kjtpay.com:8083/';
          }

        return retUrl;
    },
    pageOnload: function() {
        $('body').attr('time', (new Date().getTime())/1000);
    },
    pageLeave: function() {
        let loadTime = 0;
        if ($('#tj_img')[0]) {
            $('#tj_img').remove();
        }
        if($('body').attr('time')) {
            loadTime=$('body').attr('time');
        }
        let params = this.getFingerPrintObj().params;
        if (!params) {
            params = "atyp=pv";
        } else {
            params=`${params}&atyp=pv`;
        }
        if (document.referrer) {
        	params=`${params}&preurl=${encodeURIComponent(document.referrer)}`;
        }
	    if (document.title) {
            params=`${params}&pgtit=${encodeURIComponent(document.title)}`;
        }

        if (this.getFingerPrintObj().finger) {
            params=`${params}&devfp=${encodeURIComponent(this.getFingerPrintObj().finger)}`;
        }

        if ($('body').attr('pgId')) {
            params=`${params}&pgid=${encodeURIComponent($('body').attr('pgId'))}`;
        }

        if (sessionStorage.getItem('lastPgId') && sessionStorage.getItem('lastPgId')!=$('body').attr('pgId')) {
            params=`${params}&prepgid=${encodeURIComponent(sessionStorage.getItem('lastPgId'))}`;
        }

        if(this.getSessionId()) {
            params=`${params}&sid=${encodeURIComponent(this.getSessionId())}`;
        }

    	var img = document.createElement("img");
    	img.setAttribute("id", "tj_img");
    	img.src = this.getUrl()+"web/ac/t.gif?tp="+((new Date().getTime()/1000) - parseInt(loadTime))+"&"+params;
    	document.body.appendChild(img);
    },
    collect: function(ev) {
        this.iosInit();
        if(!ev) {
            return;
        }
        // console.log('aaa', this.getSessionId())
        if(!$(ev.currentTarget).attr('kjt-data')) {
          return;
        }
        /*
        let environmentLink = {
            development: 'https://zdata.kjtpay.com:8083/web/ac',
            staging: 'https://zdata.kjtpay.com:8083/web/ac',
            staging1: 'https://c1data.kjtpay.com:8083/web/ac',
            staging2: 'https://c2data.kjtpay.com:8083/web/ac',
            release: 'https://data.kjtpay.com:8083/web/ac',
        }

      */

        
        let headers = {
            "Content-Type": "application/json",
            "Finger-Print":this.getFingerPrintObj().finger
        };
        let obj = {
            atyp: 'click',
            devfp: this.getFingerPrintObj().finger,
            elmtyp: ev.currentTarget.computedRole,
            elmk: $(ev.currentTarget).attr('kjt-data'),
            elmtit: ev.currentTarget.computedName
        }

        if (document.referrer) {
        	obj.preurl=encodeURIComponent(document.referrer);
        }
	    if (document.title) {
            obj.pgtit = document.title;
        }

        if ($('body').attr('pgId')) {
            obj.pgid=$('body').attr('pgId');
        }

        if (sessionStorage.getItem('lastPgId') && sessionStorage.getItem('lastPgId')!=$('body').attr('pgId')) {
            obj.prepgid=sessionStorage.getItem('lastPgId') ;
        }

        if(this.getFingerPrintObj().params) {
            obj.sr = this.getFingerPrintObj().params.split('=')[1];
        }

        if(this.getSessionId()) {
            obj.sid=this.getSessionId();
        }
        let opt = {
            type: 'POST',
            dataType: "json",
            url:  this.getUrl() + "web/ac",
            headers: headers,
            timeout: 10000,
            data: obj,
            success: function(data) {
                // console.log('testtest', data);
            },
            fail: function(err) {

            }
        };

        $.ajax(opt);
    },
   getSessionId: () => {  
        var c_name = 'JSESSIONID';  
        if(document.cookie.length>0){  
           c_start=document.cookie.indexOf(c_name + "=")  
           if(c_start!=-1){   
             c_start=c_start + c_name.length+1   
             c_end=document.cookie.indexOf(";",c_start)  
             if(c_end==-1) c_end=document.cookie.length  
             return unescape(document.cookie.substring(c_start,c_end));  
           }  
        }  
    }  
}


// WEBPACK FOOTER //
// ./src/util/fingerPrint.js